import { useCallback, useMemo, useState } from 'react'
import { Paper, Box, Typography, Collapse, Button } from '@mui/material'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  accountConnectionsPlatformMap,
  accountIconMap,
  EAccountConnectionType,
  IAccount,
} from '../../../../../constants/chat'
import ImgTag from '../../../../../components/ImgTag'
import { ImageLinks, LogoTypeSocial } from '../../../../../constants/image-link'
import { axiosInstance } from '../../../../../hooks/useAxios'
import { message } from 'antd'
import { ERRORS_MESSAGE_MAPPER } from '../../../../../constants/errors'
import { FiEye } from 'react-icons/fi'
import AssignUserLists from './AssignUserLists'
interface IConnectedAccountCardProps {
  platform: EAccountConnectionType
  accounts: IAccount[]
  mutate?: () => void
}

const ConnectedAccountCard = ({
  accounts,
  platform,
  mutate,
}: IConnectedAccountCardProps) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [expanded, setExpanded] = useState(false)
  const open = Boolean(anchorEl)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  

  const canManage = useMemo(() => {
    return platform === EAccountConnectionType.Facebook
  }, [platform])

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box
          display="flex"
          alignItems="center"
          onClick={toggleExpand}
          sx={{ cursor: 'pointer' }}
        >
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              marginX: 1,
            }}
          >
            <ImgTag
              imageUrl={ImageLinks[accountIconMap[platform] as LogoTypeSocial]}
              name={platform}
              size={35}
            />
          </Box>
          <Typography variant="h6">
            {accountConnectionsPlatformMap[platform]}
          </Typography>
        </Box>
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={toggleExpand}
            sx={{ gap: 1 }}
          >
            <FiEye /> รายละเอียด
          </Button>
        </Box>
      </Box>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {accounts.map((account, index) => (
          <div key={index}>
            <div key={index}>
              <AssignUserLists
                platform={platform}
                mutate={mutate}
                account={account}
              />
            </div>
          </div>
        ))}
      </Collapse>
    </Paper>
  )
}

export default ConnectedAccountCard
